
























import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions, mapState } from "vuex";
import ProductCard from "@/components/ProductCard.vue";

const InlineCartProps = Vue.extend({
  inheritAttrs: false,
  computed: {
    ...mapState("global", ["cart"]),
  },
});

@Component({
  components: {
    ProductCard,
  },
})
export default class CartSummary extends InlineCartProps {}
